import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "androidLinkPipe",
})
export class AndroidLinkPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return (
            "https://play.google.com/store/apps/details?id=com.mylocalpitch&referrer=utm_source%3D" +
            value
        );
    }
}
